/* XXX: questo reducers riusa i dati delle action querystringsearch ed estrae, se ci sono i dati di geolocations */
import { omit } from 'lodash';

const GET_QUERYSTRING_RESULTS = 'GET_QUERYSTRING_RESULTS';
const RESET_QUERYSTRING_RESULTS = 'RESET_QUERYSTRING_RESULTS';

const initialState = {
  error: null,
  items: [],
  loaded: false,
  loading: false,
  subrequests: {},
};

/**
 * querystringsearch reducer.
 * @function querystring
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function querystringsearchGeo(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_QUERYSTRING_RESULTS}_PENDING`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                ...(state.subrequests[action.subrequest] || {
                  items: [],
                }),
                items: [],
                error: null,
                loaded: false,
                loading: true,
              },
            },
          }
        : {
            ...state,
            error: null,
            loading: true,
            loaded: false,
          };
    case `${GET_QUERYSTRING_RESULTS}_SUCCESS`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: null,
                items: action.result?.geolocations || [],
                loaded: true,
                loading: false,
              },
            },
          }
        : {
            ...state,
            error: null,
            items: action.result?.geolocations || [],
            loaded: true,
            loading: false,
          };
    case `${GET_QUERYSTRING_RESULTS}_FAIL`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: action.error,
                items: [],
                loading: false,
                loaded: false,
              },
            },
          }
        : {
            ...state,
            error: action.error,
            items: [],
            loading: false,
            loaded: false,
          };
    case RESET_QUERYSTRING_RESULTS:
      return action.subrequest
        ? {
            ...state,
            subrequests: omit(state.subrequests, [action.subrequest]),
          }
        : {
            ...state,
            error: null,
            items: [],
            loading: false,
            loaded: false,
          };
    default:
      return state;
  }
}
